import {SuperUserGuard} from '../../guards/permission.guard';
import {
  UserBrandingEditComponent
} from './user-branding-edit/user-branding-edit.component';
import {
  UserBrandingDashboardComponent
} from './user-branding-dashboard/user-branding-dashboard.component';
import {UserBrandingComponent} from './user-branding.component';


export const UserBrandingRoutes = [
  {
    path: "user-branding",
    canActivate: [SuperUserGuard],
    component: UserBrandingComponent,
    children: [
      {
        path: "dashboard",
        component: UserBrandingDashboardComponent
      },
      {
        path: "edit/:domainNameAsUid",
        component: UserBrandingEditComponent,
      },
      { path: "**", redirectTo: "dashboard" },
    ],
  },
];
